// @flow

import React, { Component } from 'react';
import { History } from 'react-router-dom';
import { connect } from 'react-redux';

import type { AppStore } from '../../types/store';
import type { AuthState } from '../../store/reducers/auth';
import type { UserStore } from '../../types/user';

import { loadLocalStorageToStore, routeSession } from '../../actions/auth';
import userActions from '../../actions/user';

type Props = {
  history: History,
  user: UserStore,
  routeUser: () => void,
  routeSession: () => void,
  loadLocalStorageToStore: () => void,
  user: UserStore,
  auth: AuthState
};

class Home extends Component<Props> {
  props: Props
  componentWillMount() {
    if (this.props.user.data) {
      this.props.routeUser();
    } else if (this.props.auth.authenticated) {
      this.props.routeSession();
    } else {
      this.props.loadLocalStorageToStore();
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    if (!this.props.user.data && nextProps.user.data) {
      this.props.routeUser();
    } else if (this.props.auth.loaded !== nextProps.auth.loaded) {
      this.props.routeSession();
    }
  }

  render() {
    return (
      <div />
    );
  }
}

const mapStateToProps = (appState: AppStore) => ({
  user: appState.user,
  auth: appState.auth
});

export default connect(mapStateToProps, {
  loadLocalStorageToStore,
  routeSession,
  routeUser: userActions.routeUser
})(Home);



// WEBPACK FOOTER //
// ./src/components/pages/home.js